import type {CodeListId, CombinedCodeListId} from 'domainTypes/codelistId';

export type {
  Code,
  CodeList,
  CodeListId,
  CombinedCodeListId,
  LocalCodeListId,
} from 'domainTypes/codelistId';

//----- CodeList, Code ----------------------------------------------------------------------------

export const CombinedCodeListIds: Readonly<CombinedCodeListId[]> = [
  'WORK_AND_EXPRESSION_ROLE_TYPE',
] as const;

export const PartCodeLists: Readonly<Record<CombinedCodeListId, CodeListId[]>> =
  {
    WORK_AND_EXPRESSION_ROLE_TYPE: ['WORK_ROLE_TYPE', 'EXPRESSION_ROLE_TYPE'],
  };
